import { useEffect, useState } from 'react';

export default function AboutHero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="relative min-h-[90vh] bg-gradient-to-b from-[#0a0e27] via-[#0f1435] to-[#1a1f3a] overflow-hidden flex items-center">
      {/* Dot Pattern Overlay */}
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }}></div>

      {/* Animated Gradient Orbs */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-[#007dff]/20 rounded-full blur-[120px] animate-pulse"></div>
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-[#0066dd]/20 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: '1s' }}></div>

      <div className="relative max-w-[1400px] mx-auto px-8 py-20 w-full">
        <div className="max-w-4xl mx-auto text-center">
          {/* Üst Etiket */}
          <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#007dff]/30 bg-[#007dff]/5 mb-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="w-2 h-2 bg-[#007dff] rounded-full animate-pulse"></div>
            <span className="text-[#007dff] text-sm font-medium tracking-wide">Hakkımızda</span>
          </div>

          {/* Ana Başlık */}
          <h1 className={`mb-8 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="text-white font-bold text-6xl lg:text-7xl mb-4">
              Dijital Dünyada
            </div>
            <div className="text-transparent bg-clip-text bg-gradient-to-r from-[#007dff] to-[#0066dd] font-bold text-6xl lg:text-7xl">
              Güvenilir Ortağınız
            </div>
          </h1>

          {/* Diagonal Çizgi */}
          <div className="relative h-1 w-48 mx-auto mb-8 overflow-hidden">
            <div className={`absolute inset-0 bg-gradient-to-r from-[#007dff] to-transparent transition-all duration-1000 delay-400 ${isVisible ? 'translate-x-0' : '-translate-x-full'}`}></div>
          </div>

          {/* Alt Açıklama */}
          <p className={`text-white/70 text-xl leading-relaxed max-w-3xl mx-auto transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            2015 yılından bu yana sigorta sektöründe dijital dönüşümün öncüsüyüz. 
            Müşterilerimizin başarısı için en yenilikçi çözümleri sunuyoruz.
          </p>
        </div>

        {/* Scroll Indicator - Daha aşağıda */}
        <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white text-sm">Keşfet</span>
          <i className="ri-arrow-down-line text-[#007dff] text-2xl"></i>
        </div>
      </div>
    </div>
  );
}
